<ng-template let-entity="entity" #actionsTemplate>
  <a class="btn btn-sm btn-yellow ms-1" [routerLink]="[entity.id]" i18n-ngbTooltip="@@OpenCustomerOverviewAsOperatorTooptip" ngbTooltip="Kunde als Betreiber öffnen">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tool">
      <path
        d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z">
      </path>
    </svg>
  </a>
</ng-template>

<!-- <main class="flex-shrink-0">
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <div class="row card-title">
              <div class="col-12">
                <h5 class="m-0 p-0">
                  <span class="float-start" i18n="@@CustomerOverviewHeader">Kundenübersicht ({{ tableFunctions.total$ | async }})</span>
                </h5>
              </div>
            </div>
          </div>
          <div class="card-body">

            <div class="float-end">
              <button class="btn btn-yellow ms-1" [routerLink]="['/create']" ngbTooltip="Neuen Kunden anlegen">
                <app-svg source="icons/feather/user-plus" height="18"></app-svg>
                <span class="d-none d-md-inline ps-2">Kunden anlegen</span>
              </button>
            </div>

            <div *ngIf="tableReady">
              <app-table [table]="table"></app-table>
            </div>
            <div *ngIf="!tableReady" class="loading-spinner-container">
              <div class="spinner-border text-primary loading-spinner-md" role="status">
                <span class="visually-hidden-focusable">Loading...</span>
              </div>
            </div>
          </div>
          <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
            <div class="d-flex">
              <div class="flex-fill d-none d-md-inline">
                <div class="d-flex">
                  <div class="flex p-2" i18n="@@Records#">Elemente pro Seite</div>
                  <div class="flex">
                    <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                      class="form-control form-select custom-select" aria-label=""
                      (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
                      <option [ngValue]="10">10</option>
                      <option [ngValue]="25">25</option>
                      <option [ngValue]="50">50</option>
                      <option [ngValue]="100">100</option>
                      <option [ngValue]="250">250</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
                <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                  [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                  [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
                </ngb-pagination>
              </div>
              <div class="flex-fill justify-content-end d-none d-md-inline">
                <div class="d-flex float-end">
                  <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
                  <div class="flex">
                    <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                      aria-label="">
                      <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                        [ngValue]="i + 1">{{ i + 1 }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main> -->

<main id="customers-table">
  <div class="card">
    <div class="card-header">
      <div class="row card-title">
        <div class="col-12">
          <h5 class="m-0 p-0">
            <span class="float-start" i18n="@@CustomerOverviewHeader"><app-svg source="icons/feather/user" height="18" class="me-2"></app-svg>Kundenübersicht</span>
          </h5>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="clearfix">
        <form class="float-start">
          <div i18n="@@Search" style="min-width:200px;">
            <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
          </div>
        </form>
        <div class="float-end">
          <ng-container *ngIf="this.isOperatorView && this.isTestingOrDevStage">
            <button class="btn btn-yellow ms-2" id="bill_now" ngbTooltip="Sofort Abrechnen für alle Kunden" (click)="testMonthEnd()">
              <app-svg source="icons/feather/dollar-sign" width="16"></app-svg>
              <span class="d-none d-md-inline ps-2">Sofort Abrechnen</span>
            </button>
          </ng-container>

          <ng-container *ngIf="this.isOperatorView && !isSupporter">
            <button class="btn btn-yellow ms-2" id="creat_customer" [routerLink]="['register']" i18n-ngbTooltip="@@AddNewCustomerTooltip" ngbTooltip="Neuen Kunden anlegen">
              <app-svg source="icons/feather/user-plus" width="16"></app-svg>
              <span class="d-none d-md-inline ps-2" i18n="@@AddNewCustomer">Kunden anlegen</span>
            </button>
          </ng-container>
        </div>
      </div>
      <div *ngIf="tableReady">
        <app-table [table]="table"></app-table>
      </div>
      <div *ngIf="!tableReady" class="loading-spinner-container">
        <div class="spinner-border text-primary loading-spinner-md" role="status">
          <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
        </div>
      </div>
    </div>

      <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
        <div class="d-flex">
          <div class="flex-fill d-none d-md-inline">
            <div class="d-flex">
              <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
              <div class="flex">
                <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize"
                        class="form-control form-select custom-select" aria-label=""
                        (change)="tableFunctions.onPageSizeChange(activeComponentClassName)">
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                  <option [ngValue]="250">250</option>
                </select>
              </div>
            </div>
          </div>

          <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
            <ngb-pagination #pagination [collectionSize]="(tableFunctions.total$ | async)!"
                            [(page)]="tableFunctions.page" [pageSize]="tableFunctions.pageSize"
                            [maxSize]="tableFunctions.page == 3 ? 3 : 2" [boundaryLinks]="true" [rotate]="true">
            </ngb-pagination>
          </div>

          <div class="flex-fill justify-content-end d-none d-md-inline">
            <div class="d-flex float-end">
              <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
              <div class="flex">
                <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select"
                        aria-label="">
                  <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index"
                          [ngValue]="i + 1">
                    {{ i + 1 }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</main>
<router-outlet></router-outlet>
